<template>
  <v-container fluid>
    <FarmTable />
  </v-container>
</template>

<script>
//components
import FarmTable from "@/components/farms/FarmTable.vue";
export default {
  components: {
    FarmTable,
  },
  data: () => ({
    tabs: 0,
    distributors: ["Proagro", "Agromich", "Puma golf"],
  }),
};
</script>
